// extracted by mini-css-extract-plugin
export default {"button":"KVjiDK","disable-theme":"bu0moo","disableTheme":"bu0moo","rounded":"cq6MeD"};